import React from 'react';
import PropTypes from 'prop-types';
import { OutlineButton } from '../../@communityshare/ui/Button';
import { SolidButton } from '../../@communityshare/ui/Button';
import StringField from '../../forms/_fields_v2/StringField';
import TextAreaField from '../../forms/_fields_v2/TextAreaField';
import FormTemplate from '../../dialogs_common/FormTemplate';
import FormField from '../../forms/_common/FormField';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';
import SelectField from '../../forms/_fields_v2/SelectField';
import ImageField from '../../forms/_fields_v2/ImageField';

Form.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};

Form.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function Form(props) {
  const {
    data,
    errors,
    showErrors,
    alert,
    onChange,
    onSubmit,
    onClose
  } = props;

  return (
    <FormTemplate
      title="Update network"
      subtitle={(
        <>
          <span className="block">
            The fields you can modify are shown below.
          </span>
        </>
      )}
      onClose={onClose}
      alert={alert}
      body={(
        <div className="space-y-4">
          <FormField name="name" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Name"
                placeholder="Name..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="subdomain" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Subdomain"
                placeholder="Subdomain..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="logo" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <ImageField
                label="Logo"
                placeholder="Image..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="screeningUrl" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Screening URL"
                placeholder="URL..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="trainingUrl" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Training URL"
                placeholder="URL..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="googleDriveUrl" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Google Drive URL"
                placeholder="URL..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="educatorBanner" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <TextAreaField
                label="Educator banner"
                placeholder="Text..."
                rows={3}
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="partnerBanner" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <TextAreaField
                label="Partner banner"
                placeholder="Text..."
                rows={3}
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="grants" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <SelectField
                label="Grants"
                value={field.value}
                // placeholder="Select option..."
                options={{
                  data: ['Yes', 'No'].map(function(value) {
                    return {
                      id: value,
                      data: {
                        name: value
                      }
                    };
                  })
                }}
                optionLabel="name"
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="isActive" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <SelectField
                label="Active"
                value={field.value === true ? 'Yes' : 'No'}
                // placeholder="Select option..."
                options={{
                  data: ['Yes', 'No'].map(function(value) {
                    return {
                      id: value,
                      data: {
                        name: value
                      }
                    };
                  })
                }}
                optionLabel="name"
                // onChange={field.onChange}
                onChange={function(id) {
                  field.onChange(id === 'Yes' ? true : false);
                }}
              />
            )}
          </FormField>
          <FormField name="city" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="City"
                placeholder="City..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="state" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="State"
                placeholder="State..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
        </div>
      )}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onClose}>
            Cancel
          </OutlineButton>
          <SolidButton onClick={onSubmit}>
            Save changes
          </SolidButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
